<template>
<div>
    <Header />
    
    <div v-if="!loading" class="form-container">
        <vm-form>

            <vm-card list :header="__('company')">
                <vm-row>
                    <vm-group c6>
                        <vm-label :text="__('company_name')" />
                        <vm-input v-model="customer.name" maxbo disabled />
                    </vm-group>
                    <vm-group c3>
                        <vm-label :text="__('org_number')" />
                        <vm-input v-model="customer.orgnr" maxbo disabled />
                    </vm-group>
                    <vm-group c3>
                        <vm-label :text="__('customer_number')" />
                        <vm-input v-model="customer.number" maxbo disabled />
                    </vm-group>
                </vm-row>
            </vm-card>

            <vm-card list :header="'Melding fra ' + flow.approver.fname">
                <div class="approval-info-c">
                    <div class="approval-info approval-none">
                        <div class="approval-info-icon">
                            <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(0.55);">
                                <path d="M16 0C7.2 0 0 7.2 0 16C0 24.8 7.2 32 16 32C24.8 32 32 24.8 32 16C32 7.2 24.8 0 16 0ZM17.5 24.7C17.5 24.8 17.4 24.9 17.3 24.9H14.8C14.7 24.9 14.6 24.8 14.6 24.7V12.6C14.6 12.5 14.7 12.4 14.8 12.4H17.3C17.4 12.4 17.5 12.5 17.5 12.6V24.7ZM17.5 9.8C17.5 9.9 17.4 10 17.3 10H14.8C14.7 10 14.6 9.9 14.6 9.8V7.3C14.6 7.2 14.7 7.1 14.8 7.1H17.3C17.4 7.1 17.5 7.2 17.5 7.3V9.8Z"/>
                            </svg>
                        </div>
                        <div class="approval-info-text">
                            <label>{{ 'Fraktavtalen er godkjent, trykk Bekreft for å oppdatere frakt-tabellen' }}</label>
                        </div>
                    </div>
                </div>
                <div v-if="$parent.confirmed" class="approval-info-c">
                    <div class="approval-info approval-none">
                        <div class="approval-info-icon">
                            <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(0.55);">
                                <path d="M16 0C7.2 0 0 7.2 0 16C0 24.8 7.2 32 16 32C24.8 32 32 24.8 32 16C32 7.2 24.8 0 16 0ZM17.5 24.7C17.5 24.8 17.4 24.9 17.3 24.9H14.8C14.7 24.9 14.6 24.8 14.6 24.7V12.6C14.6 12.5 14.7 12.4 14.8 12.4H17.3C17.4 12.4 17.5 12.5 17.5 12.6V24.7ZM17.5 9.8C17.5 9.9 17.4 10 17.3 10H14.8C14.7 10 14.6 9.9 14.6 9.8V7.3C14.6 7.2 14.7 7.1 14.8 7.1H17.3C17.4 7.1 17.5 7.2 17.5 7.3V9.8Z"/>
                            </svg>
                        </div>
                        <div class="approval-info-text">
                            <label>{{ 'Du har bekreftet denne fraktavtalen.' }}</label>
                        </div>
                    </div>
                </div>
                
                <vm-row v-if="!$parent.confirmed">
                    <vm-group c4 />
                    <vm-group c4>
                        <vm-button :text="'Bekreft'" :icon="'download'" @clicked="onSubmit" />
                    </vm-group>
                    <vm-group c4 />
                </vm-row>

            </vm-card>

            <vm-card list :header="'Hva vil du gjøre?'">
                <vm-row style="padding: 20px 40px;">
                    <vm-group c6>
                        <vm-button :text="'Last ned fraktavtale'" :icon="'download'" @clicked="onDownloadClicked" />
                    </vm-group>
                    <vm-group c6>
                        <vm-button :text="'Vis fraktavtale'" :icon="'preview'" @clicked="onPreviewClicked" />
                    </vm-group>
                </vm-row>
            </vm-card>

        </vm-form>
    </div>

    <ve-preview-popup v-if="previewPopup" :blob="previewData" :filename="filename" @close="previewPopup = false" />

</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import downloadjs from 'downloadjs'
import maxbo from '../maxbo';
import log from '../log';
import shippingapi from '../shippingapi';
import verified from '../verified';

import Header from '../components/nav/Header'

export default {
name: 'Home',
components: {
    Header
},
data() {
    return {
        loading: true,
        customer: {},
        shipping: {},
        flow: {
	        additionalInfo: ''
        },
        previewPopup: false,
        previewData: '',
        filename: ''
    }
},
methods: {
    // --- PDF Logic ------------------------------------
    async onDownloadClicked() {
        if (this.previewData == '') {
            const pdfStrings = shippingapi.getPDFValues(this.shipping, this.$parent.sheetData.values);
            const response = await maxbo.generatePDF(this.$root.translations, this.customer, pdfStrings, this.flow.additionalInfo);
            this.previewData = response.data;
        }
        downloadjs("data:application/pdf;base64," + this.previewData, this.filename + ".pdf", "application/pdf");
    },
    async onPreviewClicked() {
        if (this.previewData == '') {
            const pdfStrings = shippingapi.getPDFValues(this.shipping, this.$parent.sheetData.values);
            console.log('pdf', pdfStrings);
            const response = await maxbo.generatePDF(this.$root.translations, this.customer, pdfStrings, this.flow.additionalInfo);
            this.previewData = response.data;
        }
        this.previewPopup = true;
    },
    // --------------------------------------------------
    async onSubmit() {
        this.submitting = true;
        this.$parent.setLoading(true, 'Bekrefter fraktavtale...');

        const pdfStrings = shippingapi.getPDFValues(this.shipping, this.$parent.sheetData.values);
        
        // Set recipient action
        const flowStep = Number(this.flow.step) + 1;
        let action = this.flow.action == 'confirm' ? 'finalconfirm' : 'completed';
        let actor = this.flow.associate;

        // Get envelope from parent-view
        const envelope = this.$parent.getEnvelope();

        // Set recipient if associate is different from editor
        if (!this.customer.editorIsOwner && this.flow.action != 'finalconfirm') {
            await verified.setRecipient(envelope, 'associate', this.flow.associate);
        }

        // Prepare mail
        const mail = {
            step: flowStep,
            action: action,
            subject: 'Ny fraktavtale',
            title: 'Ny fraktavtale',
            message: `Hei ${this.flow.associate.fname}, ${this.flow.editor.fname} har laget en ny fraktavtale for en av dine kunder.`,
            button: 'Bekreft',
            hint: 'Trykk på knappen for å gå til skjema og bekrefte avtalen. NB! Det er viktig at du gjøre dette for at alt skal bli rett lagret i arkivet.'
        }

        // Prepare flow status
        this.flow.step = flowStep;
        this.flow.action = action;
        this.flow.actor = actor;

        // Prepare userdata
        const userdata = {
            customer: this.customer,
            shipping: this.shipping,
            flow: this.flow,
            mail: mail,
            pdfStrings: pdfStrings
        };

        // Set userdata and trigger next recipient
        await verified.setUserdata(envelope, userdata);

        this.$parent.confirmed = true;
        this.$parent.setLoading(false);
        this.submitted = true;
    }
},
async created() {
	
    this.$parent.setLoading(true, 'Laster inn data...');

    // Get cached data from parent-view
    this.customer = await this.$parent.getCustomer();
    this.shipping = await this.$parent.getShipping();
    this.flow = this.$parent.getFlow();

    // Prepare shipping object for pdf
    this.filename = 'Fraktavtale ' + this.customer.name;
    shippingapi.setMaxDiscounts(this.shipping, this.$parent.sheetData.values);
    shippingapi.setOriginalPrices(this.shipping, this.$parent.sheetData.values);

    this.loading = false;
    this.$parent.setLoading(false);
}
}
</script>
<style scoped>

.updated-message {
    width: 400px;
    padding: 10px 0px;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: -30px;
    border-radius: 5px;
    background-color: white;
}
.updated-message path {
    fill: #004976;
}

</style>